import styled from "@emotion/styled"
import { css } from "@emotion/react"

const dynamicStyle = ({ theme, colorVariant }) => css`
  background: ${(colorVariant === "Light" && theme.palette.common.white) || theme.palette.gray[50]};
`

const ListFiveItemContainerBlock = styled.div`
  ${({ theme }) => theme.breakpoints.down("xl")} {
    width: calc(50% - 50px);
    height: 100%;
    border-radius: 20px 20px 0 0;
  }

  ${({ theme }) => theme.breakpoints.up("xl")} {
    width: 100%;
    border-radius: 20px 0 0 20px;
  }

  ${({ theme }) => theme.breakpoints.between("xl", "2xl")} {
    height: calc(50% - 64px);
  }

  ${({ theme }) => theme.breakpoints.up("2xl")} {
    height: calc(50% - 80px);
  }

  ${dynamicStyle}
`

export default ListFiveItemContainerBlock
